import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { "txt-center": "" }
const _hoisted_2 = { "txt-center": "" }
const _hoisted_3 = {
  "mtb-0": "",
  "txt-center": ""
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_image, { src: _ctx.StartSurvey }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", {
        "m-tb-1": "",
        "txt-center": ""
      }, "Entrepreneurial Assessment", -1)),
      _createElementVNode("p", _hoisted_3, [
        (_ctx.user.type === 'founder')
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Next up, we will require you to rate your founding team from an entrepreneurial context. Doing so will enable us to match you with talent that not only compliment your technical skills but also elevate the entrepreneurial abilities of your team. "))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, " You're only a few steps away from being matched to high-value opportunities throughout our global network. Tell us a little more about your entrepreneurial experience. Choose the first response, or closest fit that comes to mind. "))
      ])
    ])
  ], 64))
}